import React, { useState } from 'react';
import './TabContent.style.css';
import { RightOutlined } from '@ant-design/icons';

const TabContent = ({
  items = [],
  labelWidth = 200,
  labelStyle = {},
  showTitle = true,
  titleStyle = {},
  activeKey,
  onChange = () => {},
  suffix = <RightOutlined />,
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const [key, setKey] = useState(activeKey ?? items[0].key);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  const handleTabKeyChange = ({ label, key, children }) => {
    setKey(key);
    onChange && onChange({ label, key, children });
  };

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <div className="tab_content_layout">
      <ul className="tab_content_label" style={{ width: labelWidth }}>
        {items.map((_item) => (
          <li
            key={_item.key}
            onClick={() => handleTabKeyChange(_item)}
            style={{ ...labelStyle }}
            className={
              _item.key === key ? `tab_content_label_active` : undefined
            }
          >
            {_item.label}
            {suffix}
          </li>
        ))}
      </ul>
      <div className="tab_content_wrapper">
        {showTitle && (
          <h4 className="tab_content_title" style={{ ...titleStyle }}>
            {items.find((_item) => _item.key === key).label}
          </h4>
        )}
        <div className="tab_content_contents">
          {items.find((_item) => _item.key === key).children}
        </div>
      </div>
    </div>
  );
};

export default TabContent;
